import { type TFunction } from "i18next";
import _ from "lodash";

import apolloClient from "@/apollo";
import { addDangerFlash, addSuccessFlash } from "@/components/flash/flashReducer";
import { type ContactStatusFragment, MutateContactDocument, MutateTaskDocument } from "@/gql/graphql";
import handleError, { MutationError } from "@/handleError";
import store from "@/store";

import type { ValuesType } from "./formUtils";

export const saveTask = async (
  session: SessionInterface,
  existingTask: Nilable<CCTaskInput>,
  states: ContactStatusFragment[],
  values: ValuesType,
  t: TFunction,
) => {
  const { statusId, contact } = values;

  try {
    const { data } = await apolloClient.mutate({
      mutation: MutateTaskDocument,
      variables: {
        values: _.omit(values, ["infos", "contact", "statusId", "caddfields"]),
        customerId: session.currentCustomer.id,
        projectId: session.currentProject.id,
        id: existingTask?.id,
      },
    });

    if (!data?.mutateTask) {
      throw new MutationError();
    }

    if (statusId && contact) {
      const status = states.find((s) => s.id === statusId);

      const { data } = await apolloClient.mutate({
        mutation: MutateContactDocument,
        variables: {
          customerId: session.currentCustomer.id,
          projectId: session.currentProject.id,
          id: contact.id,
          contact: { statusId: status?.id },
        },
      });

      if (!data?.mutateContact) {
        throw new MutationError();
      }
    }

    const transString = existingTask?.id ? "customerContacts:edit_form.updated" : "customerContacts:new_form.created";

    store.dispatch(addSuccessFlash(t(transString)));

    return data.mutateTask;
  } catch (e) {
    store.dispatch(addDangerFlash(t("translation:global.general_error")));
    handleError(e);
  }
};
